import PhoneCallSvg from '@assets/images/svg/phone-call.svg';
import { UI_PRIMITIVES } from '@/core/constants/uiColors';
import React from 'react';
import { View } from 'react-native';

export interface PhoneCallIconProps {
    size?: number;
    color?: string;
}

export function PhoneCallIcon({ size = 14, color = UI_PRIMITIVES.redLight }: Readonly<PhoneCallIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <PhoneCallSvg width={size} height={size} color={color} />
        </View>
    );
}

export default PhoneCallIcon;
